import { render, staticRenderFns } from "./indexHeader.vue?vue&type=template&id=b8963b58&scoped=true&"
import script from "./indexHeader.vue?vue&type=script&lang=js&"
export * from "./indexHeader.vue?vue&type=script&lang=js&"
import style0 from "./indexHeader.vue?vue&type=style&index=0&id=b8963b58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8963b58",
  null
  
)

export default component.exports